var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemsBorrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14633 0L6.04815 0.550717C6.04815 2.28347 6.09142 5.30376 6.80011 7.63538C9.95402 8.40357 11.5445 8.40357 14.6984 7.63538C15.4179 5.30917 15.4504 2.95375 15.4558 0.550717L14.3522 0C14.1141 0.310522 13.7192 0.813633 13.1728 1.43738C12.7833 1.87882 12.3722 2.32242 11.9773 2.67081C11.7825 2.84501 11.5932 2.9954 11.4038 3.11279C11.2091 3.23181 11.0197 3.3346 10.7493 3.3346C10.4788 3.3346 10.2894 3.23181 10.0947 3.11279C9.90533 2.9954 9.71599 2.84501 9.52123 2.67081C9.12632 2.32242 8.71517 1.87882 8.32567 1.43738C7.77928 0.813633 7.38436 0.310522 7.14633 0ZM6.68109 8.60373L0 21.9713C0.0151474 22.0308 0.0432783 22.0958 0.116851 22.1769C0.225047 22.3013 0.418718 22.4528 0.69083 22.5935C1.23614 22.8856 2.08223 23.1507 3.11063 23.3616C5.16635 23.7836 7.96321 24 10.7493 24C13.5353 24 16.3322 23.7836 18.3879 23.3616C19.4157 23.1507 20.2651 22.8856 20.8061 22.5935C21.082 22.4528 21.2713 22.3013 21.3795 22.1769C21.4552 22.0958 21.4823 22.0308 21.4985 21.9713L14.8174 8.60373C11.6797 9.35569 9.81877 9.35569 6.68109 8.60373Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemsBorrowIcon);
export default __webpack_public_path__ + "static/media/items_borrow_icon.b886c2c9c04ba9a28e78e2320bc448eb.svg";
export { ForwardRef as ReactComponent };